/* Publish by EComposer at 2026-10-07 16:10:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jxsjrdu5opr"]=  window.__ectimmers["ecom-jxsjrdu5opr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-jxsjrdu5opr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jxsjrdu5opr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vd61etws25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vd61etws25', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bve6xszaiq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bve6xszaiq6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-msaizo3a8cg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-msaizo3a8cg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sz8jx88dy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sz8jx88dy5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ai77k7c4av').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ai77k7c4av', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-akf9spjt7pn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-akf9spjt7pn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yxhi1rpdzw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yxhi1rpdzw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8e5b6bzhyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8e5b6bzhyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cph8iji9z6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cph8iji9z6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ym09hch371').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ym09hch371', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6dugbvdyxk4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6dugbvdyxk4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdc27sj044c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdc27sj044c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pe79px5uoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pe79px5uoq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yt642jqeb9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yt642jqeb9p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ycdug3lnog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ycdug3lnog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-473xceun3fp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-473xceun3fp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3761mfz4b2v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3761mfz4b2v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24n21geikfx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24n21geikfx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70uiqkpop4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70uiqkpop4h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v9n72o9ppmj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v9n72o9ppmj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6n1gsinjixa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6n1gsinjixa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5g5xpy1oprb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5g5xpy1oprb', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e4fti7noxqf"]=  window.__ectimmers["ecom-e4fti7noxqf"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-e4fti7noxqf"]["cujhahytf"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-e4fti7noxqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4fti7noxqf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 try{
 
} catch(error){console.error(error);}
} catch(error){console.error(error);}